<template>
  <!-- 对话框 -->
  <el-drawer :visible.sync="show" :with-header="false" :wrapperClosable="false" :before-close="closeDialog" size="80%"
    @opened="opened">

    <!-- 基本信息表单 -->
    <div class="form-box">

      <template>

        <el-form ref="form" :model="submit_data" label-width="80px" style="height: 100%; overflow-y: auto;">



          <div id="edit-container" class="map"></div>

          <el-form-item label="商家名称:" label-width='120px' style="position: relative;">
            <el-input v-model="submit_data.shop_name" @input="onInput(submit_data.shop_name)" :placeholder="submit_rules.shop_name.placeholder"
              style="width: 300px;">
            </el-input>
            <ul id="start-panel" v-if="start_panel_show">
              <li class="list" v-for="(item, index) in start_panel_innerHtml" :key="index"
                  @click="listClick(item.location.lng,item.location.lat,item.name)">

                <div style="padding-left: 20px;">
                  <p class='list-name'>

                    <span style="display: inline-block;">{{ item.name }}</span>
                  </p>
                  <p class='list-address'>{{ item.address }}</p>
                </div>

              </li>
            </ul>
          </el-form-item>

          <el-form-item label="商家电话:" label-width='120px'>
            <el-input v-model="submit_data.phone" :placeholder="submit_rules.phone.placeholder" maxlength='11'
              style="width: 300px">
            </el-input>
          </el-form-item>

          <el-form-item label="商家图片:" label-width='120px'>

            <!-- <el-input v-model="submit_data.logo_img_url" style="width: 80%;"></el-input> -->
            <el-image v-if="img_url.logo_img_url" :src="img_url.logo_img_url" class="avatar">
            </el-image>
            <el-upload :class="img_url.logo_img_url?'border-none':''" class="avatar-uploader" :action="img_upload_url"
              :show-file-list="false" :on-success="idPortraitSuccess" :before-upload="beforeAvatarUpload"
              :headers="img_headers">
              <el-button slot="trigger" v-if="img_url.logo_img_url" @click="img_url.logo_img_url='';"
                style="width: 100px; margin-top: 10px;">更换图片</el-button>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>


          </el-form-item>




          <el-form-item label="商家每日单量:" label-width='120px'>
            <el-input v-model="submit_data.day_out_num" :placeholder="submit_rules.day_out_num.placeholder"
              style="width: 150px">
            </el-input>
          </el-form-item>

          <el-form-item label="推荐司机数量:" label-width='120px'>
            <el-input v-model="submit_data.driver_num" :placeholder="submit_rules.driver_num.placeholder"
              style="width: 150px">
            </el-input>
          </el-form-item>

          <div style="padding: 10px;border: 1px solid #ccc; margin-bottom: 20px;">


            <el-form-item label="司机手机号:" label-width='120px'>

              <el-input v-model="search_data.phone" style="width: 150px;margin-right: 5px;" maxlength=11></el-input>
              <el-button @click="driverLists">搜索</el-button>

            </el-form-item>

            <!-- 表格 -->
            <el-table :data="options_driver_code" ref="multipleTable" header-cell-class-name="table-header">

              <el-table-column prop="name" label="司机名称">
                <template slot-scope="scope">
                  <el-popover trigger="hover" placement="top">
                    <p>司机唯一编码: {{ scope.row.driver_code }}</p>
                    <div slot="reference">
                      <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">{{ scope.row.name}}
                      </el-tag>
                    </div>
                  </el-popover>
                </template>
              </el-table-column>

              <el-table-column prop="phone" label="手机号" min-width="100">
              </el-table-column>


              <el-table-column label="操作" width="150">
                <template slot-scope="scope">

                  <el-button type="" @click="driverChange(scope.row.name,scope.row.driver_code)">

                    选择


                  </el-button>

                </template>
              </el-table-column>

            </el-table>

            <!-- 分页组件 -->
            <el-pagination layout="prev, pager, next" :total="result_data.count" @current-change="pages_function"
              style="margin: 20px 0; text-align: center;">
            </el-pagination>



            <el-form-item label="维护负责司机:" label-width='120px'>

              <el-input v-model="driver_name" style="width: 150px;margin-right: 5px;" disabled></el-input>

            </el-form-item>

          </div>




          <el-form-item label="商家简介:" label-width='120px'>
            <el-input v-model="submit_data.description" type="textarea"
              :placeholder="submit_rules.description.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>



          <el-form-item label="系统备注:" label-width='120px'>
            <el-input v-model="submit_data.remarks" type="textarea" :placeholder="submit_rules.remarks.placeholder"
              style="width: 80%;">
            </el-input>
          </el-form-item>

          <el-form-item label="商家物料备注:" label-width='120px'>
            <el-input v-model="submit_data.materiel_remarks" type="textarea"
              :placeholder="submit_rules.materiel_remarks.placeholder" style="width: 80%;">
            </el-input>
          </el-form-item>


        </el-form>





      </template>



    </div>

    <!-- 对话框底部按钮 -->
    <div style="display: flex;justify-content: center;margin-top: 20px;">
      <el-button type="primary" @click="onSubmit">保存</el-button>
      <el-button @click="closeDialog">关闭</el-button>
    </div>


  </el-drawer>
</template>

<script>
  var _this, map, marker;
  import {
    config
  } from '../../../utils/config'; // 配置
  export default {
    props: {
      'isShow': Boolean,
      'data': ''
    },
    watch: {

      isShow(newData, oldData) {

        _this.show = true;

        // 获取上传图片的地址
        _this.img_upload_url = config.axios_imgURL;

        _this.submit_data.ipc_shopping_code = _this.data;

        _this.driverLists();


        var loginCityName = JSON.parse(localStorage.getItem('login')).city.name

        var x = loginCityName.indexOf('/');

        for (var i = 0; i < 1; i++) {
          x = loginCityName.indexOf('/', x + 1);
        }



        // 如果为市级
        if (x < 0) {

          // 截取城市名称 如:XXXX / 截取字段
          var city_name = loginCityName.slice(loginCityName.indexOf('/') + 2)



        } else {


          // 截取城市名称 如:XXXX / XXXX / 截取字段
          var city_name = loginCityName.slice(x + 2)


        }
        // 将城市赋值
        _this.currentCity = city_name;


        // 获取异业联盟详情
        _this.$post(
          "/admin.php/Business/getIpcShoppingDetails", {
            ipc_shopping_code: _this.data
          }
        ).then(res => {

          _this.submit_data.description  = res.data.description;
          _this.submit_data.day_out_num = res.data.day_out_num;
          _this.submit_data.shop_name = res.data.shop_name;
          _this.submit_data.driver_num = res.data.driver_num;
          _this.submit_data.driver_code = res.data.driver_code;
          _this.submit_data.phone = res.data.phone;
          _this.submit_data.lng = res.data.lng;
          _this.submit_data.lat = res.data.lat;
          _this.submit_data.remarks = res.data.remarks;
          _this.submit_data.materiel_remarks = res.data.materiel_remarks;
          _this.submit_data.shop_img_hash = res.data.shop_img.hash;
          _this.img_url.logo_img_url = res.data.shop_img.url;

          marker = new AMap.Marker({
            icon: new AMap.Icon({
              image: require('@/assets/League.png'),
              size: new AMap.Size(25, 34), //图标大小
              imageSize: new AMap.Size(25, 34)
            }),
            position: [res.data.lng, res.data.lat],
            size: new AMap.Size(25, 34),
            offset: new AMap.Pixel(-13, -30)
          });
          marker.setMap(map);

          map.setFitView([marker]);


          // 获取司机名称
          _this.$post(
            "/driver/getDriverDetails", {
              driver_code: res.data.driver_code
            }
          ).then(res => {

            _this.driver_name = res.data.name

          }).catch((err) => {

          })



        }).catch((err) => {

        })


      },
    },
    data() {
      return {


        show: false,

        driver_name: '',

        options_driver_code: [],

        currentCity:'',

        start_panel_show:false,
        start_panel_innerHtml: [],

        //压缩质量
        imgQuality: 0.5,
        // 上传图片的请求头
        img_headers: {

          'token': '',
          'hash-key': '',
          'platform': 'pc',
          'app-version': 'admin',
          'port': 'admin',
          'city-tag':localStorage.getItem('city_tag')

        },
        // 图片上传地址
        img_upload_url: '',
        //上传图片
        img_url: {

          logo_img_url: '',

        },


        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          phone: '',
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          }
        },




        // 表单数据
        submit_data: {
          ipc_shopping_code:'',
          shop_name: '',
          driver_code: '',
          phone: '',
          day_out_num: '',
          driver_num: '',
          lng: '',
          lat: '',
          description: '',
          remarks: '',
          materiel_remarks: '',
          shop_img_hash: ''
        },

        submit_rules: {
          driver_code: {
            placeholder: '司机编码',
            rules: {
              required: false,
              message: '司机编码错误',
              regulation: 'special',
              rulesData: 'driver_code'
            }
          },
          shop_name: {
            placeholder: '请输入商家名称',
            rules: {
              required: false,
              message: '地址名称需在50字之内',
              regulation: 'elt_str',
              rulesData: 50
            }
          },
          phone: {
            placeholder: '请输入商家电话',
            rules: {
              required: false,
              message: '商家电话错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          lng: {
            placeholder: '点击地图生成坐标点',
            rules: {
              required: false,
              message: '请点击地图生成坐标点',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          lat: {
            placeholder: '点击地图生成坐标点',
            rules: {
              required: false,
              message: '请点击地图生成坐标点',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          shop_img_hash: {
            placeholder: '商家图片',
            rules: {
              required: false,
              message: '商家图片错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          day_out_num: {
            placeholder: '请输入商家每日单量',
            rules: {
              required: false,
              message: '商家每日单量错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          driver_num: {
            placeholder: '请输入推荐司机数量',
            rules: {
              required: false,
              message: '推荐司机数量错误',
              regulation: 'gt_str',
              rulesData: 0
            }
          },
          description: {
            placeholder: '请输入商家简介',
            rules: {
              required: false,
              message: '商家简介小于255字',
              regulation: 'elt_str',
              rulesData: 255
            }
          },
          materiel_remarks: {
            placeholder: '请输入商家物料备注',
            rules: {
              required: false,
              message: '商家物料备注小于255字',
              regulation: 'elt_str',
              rulesData: 255
            }
          },

          remarks: {
            placeholder: '请输入备注',
            rules: {
              required: false,
              message: '备注小于255字',
              regulation: 'elt_str',
              rulesData: 255
            }
          },
        },

      };
    },
    created() {

      _this = this;

    },
    methods: {
      onInput(val){
        if (val != '' && val != null) {

          _this.start_panel_show = true;

          var keywords = _this.submit_data.shop_name;


          AMap.plugin('AMap.PlaceSearch', function () {

            if(_this.currentCity == '天津城区'){
              var autoOptions = {
                city: '天津',
                // map: map
              }
            }else{
              var autoOptions = {
                city: _this.currentCity,
                // map: map
              }
            }
            console.log(autoOptions);
            var placeSearch = new AMap.PlaceSearch(autoOptions);
            placeSearch.search(keywords, function (status, result) {

              console.log(result);

              _this.start_panel_innerHtml = [];

              for (let i = 0; i < result.poiList.pois.length; i++) {

                // 添加列表内容
                if (result.poiList.pois[i]) {
                  _this.start_panel_innerHtml.push(result.poiList.pois[i]);

                }

              }


            })
          })

        }else{
          _this.start_panel_show = false;
        }
      },

      // 地点列表点击触发
      listClick(lng, lat, text) {


        if (marker) {
          marker.setMap(null);
        }
        marker = new AMap.Marker({
          icon: new AMap.Icon({
            image: require('@/assets/League.png'),
            size: new AMap.Size(25, 34), //图标大小
            imageSize: new AMap.Size(25, 34)
          }),
          position: [lng, lat],
          size: new AMap.Size(25, 34),
          offset: new AMap.Pixel(-13, -30)
        });
        marker.setMap(map);

        _this.submit_data.lng = lng;
        _this.submit_data.lat = lat;

        _this.submit_data.shop_name = text

        _this.start_panel_show = false;

        map.setFitView([marker]);
      },


      //翻页组件的回调
      pages_function(pages) {

        //赋值
        _this.search_data.page = pages;
        //初始化列表
        _this.driverLists();

      },

      driverChange(name, code) {

        _this.submit_data.driver_code = code;

        _this.driver_name = name;

      },



      driverLists() {
        // 请求公司管理接口获取公司唯一编码
        _this.$post(
          "/driver/driverLists",
          _this.search_data,
          _this.search_rules
        ).then(res => {
          _this.options_driver_code = res.data;
          _this.result_data = res;

        }).catch((err) => {

        })
      },




      opened() {
        map = new AMap.Map("edit-container", {
          resizeEnable: true,
          zoom: 11
        });

      },

      // 商家照片上传成功后执行
      idPortraitSuccess(res, file) {

        // 将返回的哈希值存到对应的数组中
        // _this.id_card_portrait_arrway.push(res.data.img_hash);

        // 将返回的哈希值存到submit_data对象
        _this.submit_data.shop_img_hash = res.data.img_hash;

        // 设置img标签显示的图片路径
        _this.img_url.logo_img_url = URL.createObjectURL(file.raw);

      },






      // 关闭方法
      closeDialog() {
        _this.show = false;

        _this.submit_data = {
          shop_name: '',
          driver_code: '',
          phone: '',
          day_out_num: '',
          driver_num: '',
          lng: '',
          lat: '',
          description: '',
          remarks: '',
          materiel_remarks: '',
          shop_img_hash: ''
        };

        _this.search_data = {
          page: 1,
          limit: 10,
          phone: '',
        };

        _this.driver_name = '';
        _this.company_name = '';
        _this.img_url = {

          logo_img_url: '',

        }

        map && map.destroy();

      },
      // 提交
      onSubmit() {

        _this.$post(
            "/admin.php/Business/editIpcShopping",
            _this.submit_data,
            _this.submit_rules
          )
          .then(res => {

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
            _this.closeDialog();
            this.$message.success(res.msg);
          }).catch(res => {

          })

      },

      // 图片上传之前执行的函数
      beforeAvatarUpload(file) {

        // 添加请求头
        _this.img_headers.token = localStorage.getItem(config.localStorage_token_name);
        _this.img_headers['hash-key'] = _this.$hash_key();


        return new Promise(resolve => {
          const reader = new FileReader();
          const image = new Image();
          image.onload = (imageEvent) => {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            const width = image.width * _this.imgQuality;
            const height = image.height * _this.imgQuality;
            canvas.width = width;
            canvas.height = height;
            context.clearRect(0, 0, width, height);
            context.drawImage(image, 0, 0, width, height);
            const dataUrl = canvas.toDataURL(file.type);
            const blobData = _this.dataURItoBlob(dataUrl, file.type);
            resolve(blobData)
          }
          reader.onload = (e => {
            image.src = e.target.result;
          });
          reader.readAsDataURL(file);
        })
      },
      // 图片压缩方法
      dataURItoBlob(dataURI, type) {
        var binary = atob(dataURI.split(',')[1]);
        var array = [];
        for (var i = 0; i < binary.length; i++) {
          array.push(binary.charCodeAt(i));
        }
        return new Blob([new Uint8Array(array)], {
          type: type
        });
      },


    }
  };
</script>

<style scoped>
  .list {
    cursor: pointer;
    padding: 10px;
    transition: .5s;
  }
  #start-panel {
    position: absolute;
    background-color: white;
    overflow-y: auto;
    top: 35px;
    left: 0px;
    width: 280px;
    z-index: 9999;
    box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
  }
  .form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
    height: calc(100vh - 100px);
    overflow-y: auto;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .avatar-uploader {
    width: 100px;
    height: 100px;
  }

  .map {
    height: 60%;
    width: 100%;
    margin-bottom: 20px;
  }
</style>